import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { Cookie } from '../../utils/cookie';
import { TmAnalyticsExactTargetProperties } from '../model/analytics';

import { ApiBase } from './apibase.service';


export class Analytics_ExactTarget extends ApiBase {
    private cookie = new Cookie();
    protected acctBaseUrlWithEdp =
        this.cookie.UserAccessToken != undefined && this.cookie.UserAccessToken.Edp != undefined
            ? this.baseUrl + '/analyticsDataFeed/exacttarget/' + this.cookie.UserAccessToken.Edp
            : this.baseUrl;
    protected applicationBaseUrl = this.acctBaseUrlWithEdp;

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Submit application for tsc credit card.
     *   @return {number}
     */
    post(
        externalExtensionKey: string,
        analyticExactTargetProperties: TmAnalyticsExactTargetProperties,
    ): Observable<number> {
        return this.http
            .post(this.applicationBaseUrl + '/' + externalExtensionKey, analyticExactTargetProperties, {
                headers: this.userTokenJsonTypeHeader,
            })
            .map((resp) => resp.json() as number)
            .catch(this.handleError);
    }
}(Analytics_ExactTarget as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/analytics.service.ts